export function getCommitRevertStashChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {
    //Copy the changes.
    let changes = {
        ...currentCombatantStateChanges
    };

    const casterModel = combatantModels[combatantMap.casterId];
    //const targetModels = combatantMap.targetIds.map(targetId => { return combatantModels[targetId] });

    //Commit
    if (action.changeCasterCommittedData) {

        //Get all combatant hp and pp.
        let committedData = {};
        Object.keys(combatantModels).forEach( combatantId => {
            const model = combatantModels[combatantId];
            committedData[combatantId] = {
                hp: model.hp,
                //pp: model.pp, //TODO: Not sure about PP yet. Should that be part of a commit?
                status: model.status,
            }
        });

        //Set the committed data on this combatant model:
        changes.state[combatantMap.casterId].committedTurnData = committedData;
    }

    //Revert
    if (action.useCasterCommittedData) {
        const committedData = {...casterModel.committedTurnData};

        //Load combatants
        Object.keys(committedData).forEach(combatantKey => {

            if (changes.state[combatantKey] && committedData[combatantKey]) { //This person may be dead, so check that they are sill valid
              changes.state[combatantKey].hp = committedData[combatantKey].hp;
              //changes.state[combatantKey].pp = committedData[combatantKey].pp;
              changes.state[combatantKey].status = committedData[combatantKey].status;
            }
        });

        //Then clear out caster's commit
        changes.state[combatantMap.casterId].committedTurnData = false; //because Firebase will eat it
    }

    //Stash
    if (action.clearTargetCommittedData) {
        //Turn the target's `committedTurnData` to false
        combatantMap.targetIds.forEach(targetId => {
            changes.state[targetId].committedTurnData = false; //because Firebase will eat it
        });
    }


    return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/commit-revert-stash.js